import { Observable } from 'rxjs/Observable';
import { EVENTS } from '../../bus/events.const';
import { logger } from '../../logger';
import { DiscoveryWallBlockConfig, EmpathyXConfig } from '../../models';
import { ACTIONS_KEYS, GETTERS_KEYS, MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const DISCOVERY_WALL_WIRES = createWires({
  clearDiscoveryWall: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.emptySearch.resetDiscoveryWallState),
  getAllDiscoveryWallRecommendations: (observable, { store, emit }) => {
    observable.subscribe(() => {
      const { discoveryWall }: EmpathyXConfig = store.getters[GETTERS_KEYS.config.config];
      const blocks = Object.values(discoveryWall.blocks)
        .sort((a, b) => a.order - b.order);

      store.commit(MUTATIONS_KEYS.emptySearch.setDiscoveryWallLoading, true);
      /* This is what we want to generate with the chainRequests code.
       Promise.resolve()
         .then(() => store.dispatch('get-section-recommendations'))
         .then(() => store.dispatch('get-user-recommendations')) // New promise is not returned until it has resolved section results
         .then(() => store.dispatch('get-queries-recommendations')) // New promise is not returned until it has resolved user results
         .then(() => store.dispatch('get-clicks-recommendations')) // New promise is not returned until it has resolved queries results
       */
      const chainRequests = (requestChain: Promise<any>, block: DiscoveryWallBlockConfig) => requestChain
        .then(() => store.dispatch(block.requestAction))
        .catch(error => logger.error('[DiscoveryWall]', 'Request failed', error));

      const hasResults = (block: DiscoveryWallBlockConfig) => store.getters[block.resultsGetter].length > 0;

      blocks.reduce(chainRequests, Promise.resolve())
        .then(() => {
          const someBlockHasResults = blocks.some(hasResults);
          emit(someBlockHasResults
            ? EVENTS.DiscoveryWallSuccessWithResults
            : EVENTS.DiscoveryWallSuccessWithoutResults);
          store.commit(MUTATIONS_KEYS.emptySearch.setDiscoveryWallLoading, false);
        });
    });
  },
  trackDiscoveryWallBlockShow(observable: Observable<string>, { store }): void {
    observable.subscribe(blockName => {
      const { discoveryWall }: EmpathyXConfig = store.getters[GETTERS_KEYS.config.config];
      const { showTaggingGetter } = discoveryWall.blocks[blockName];
      if (showTaggingGetter) {
        const showTagging = store.getters[showTaggingGetter];
        store.dispatch(ACTIONS_KEYS.tracking.trackShow, showTagging);
      }
    });
  }
});
